import api from '@/api';

const getters = {
  countries: state => state.countries || [],
};

export const mutations = {
  SET_COUNTRIES(state, { countries }) {
    state.countries = countries;
  },
};

export const actions = {
  FETCH_COUNTRIES: ({ commit, state }) => {
    return new Promise(resolve => {
      if (state.countries) return resolve(state.countries);

      return api.fetchCountries().then(countries => {
        commit('SET_COUNTRIES', { countries });
        resolve(countries);
      });
    });
  },
};

const state = {
  countries: null,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
